<template>
  <component
    :is="type === 'deliveryMessage' ? 'amazon-delivery-message' : 'amazon-delivery-card'"
    v-bind="attributes"
    :product-external-id="productId"
    :product-sku
  />
</template>

<script lang="ts" setup>
const { productId = '', productSku = '', type } = defineProps<{
  productId?: string
  productSku?: string
  type: 'deliveryCard' | 'deliveryMessage'
}>()

const { attributes } = useAppConfig().components.prime?.[type] || {}
const { configBuyWithPrime } = useFeatureFlags()

configBuyWithPrime.src?.[type] && useScript({
  'async': true,
  'data-target-id': configBuyWithPrime.targetId,
  'src': configBuyWithPrime.src?.[type],
  'type': 'module'
})
</script>
